<template>
  <div class="modal-container">
    <modal-header :title="card.name" :close="cancel"/>
    <div class="modal-body">
      <div v-if="card.solutions && card.solutions.length>0" class="row mt-3 card-help pb-4">What can we help you with?</div>
      <div class="row">
        <div class="col-md-12">
          <div class="row mt-2" v-if="card.solutions && card.solutions.length>0">
            <div
              class="col-md-6 pt-3 p-md-0 pr-md-3 pb-md-3"
              v-for="solution in sortedSolutions"
              :key="solution.id"
            >
              <div class="card card-border">
                <a
                    @click="onModalDisplay(solution)"
                    :href="validateActionLink(solution)"
                   :target="validateOpenInNewTab(solution)">
                  <div class="card-body">
                    <div class="card-title custom-card-title">{{ solution.name }}</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div v-else class="no-solution-text">{{noSolutionsForCard}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppMixin from "../mixins/AppMixin";
import ModalHeader from "./ModalHeader";
import CategoryMixin from "../mixins/CategoryMixin";
import Constants from "@/store/constants";
export default {
  name: "CategoriesModal",
  props: {
    card: {}
  },
  components: {
    ModalHeader
  },
  mixins: [AppMixin, CategoryMixin],
  computed: {
    noSolutionsForCard() {
      return "There are no records for " + this.card.name;
    },
    sortedSolutions() {
      return this.card.solutions.sort((a, b) => a.name.localeCompare(b.name));
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    onModalDisplay(solution) {
      this.trackEvent(solution);
    },
    validateOpenInNewTab(solution) {
      return solution.url.includes('http') ? '_blank' : null
    },
    validateActionLink(solution) {
      return solution.url.includes('http') ? solution.url :
          Constants.EH_URL + solution.url;
    }
  }
};
</script>

<style scoped>
.row-category-container {
  height: 400px;
  overflow-y: auto;
}

.title {
  font-size: 20px;
  font-family: artifaktElementBold !important;
  font-weight: 600;
  margin: 0px;
  min-height: 20px;
  padding: 16px 46px 20px 24px;
  line-height: normal;
  background-color: black;
  color: #ffffff;
}
.modal-body {
  background-color: white;
  padding: 30px 30px 30px 60px;
}

.category-container {
  padding: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  border: 1px solid #b0b9c3;
  cursor: pointer;
}
.no-solution-text {
  font-size: 16px !important;
  font-family: artifaktElementRegular !important;
}
.category-title {
  color: #5f60ff;
  font-family: artifaktElementBold;
}
.card-border {
  border: 1px solid #5f60ff !important;
  height: auto;
}
#modals-container >>> .v--modal-box .v--modal {
  height: auto !important;
}
.modal-container {
  background: black;
  height: auto !important;
}

.card-help {
  font-family: artifaktElementExtraBold !important;
  font-size: 20px !important;
}
</style>